/* eslint-disable object-curly-spacing */
/* eslint-disable no-undef */
/* eslint-disable own-handles */
/* eslint-disable no-innerhtml-assign */
/* eslint-disable consistent-method-names */
/* eslint-disable no-jsdoc */
define(['endpoints', 'rest/request/singleRequestServiceFactory', 'rest/request/batchRequestServiceFactory',
    'apiKeyNames'],
function(endpoints, singleRequestServiceFactory, batchRequestServiceFactory, ApiKeyNames) {
    'use strict';

    var searchKeyName = ApiKeyNames.search;

    return {
        search: singleRequestServiceFactory(endpoints.search, searchKeyName),
        batch: batchRequestServiceFactory(100, {single: endpoints.batchSearchQuery,
                                                batchSync: endpoints.batchSyncSearch,
                                                batchSearch: endpoints.batchSearch}, searchKeyName)
    };
});



// WEBPACK FOOTER //
// ./rest/search.js